import React from "react";

/**
 * Regra de força de senha — a MESMA do backend
 * (`ChangeFirstLoginPasswordDto` e `password.util.ts`).
 *
 * Mostrada item a item, marcando em verde o que já foi satisfeito: no celular,
 * descobrir o que falta só depois do envio custa uma ida e volta de rede e, se o
 * colaborador estiver no login, uma tentativa a menos antes do bloqueio.
 */
export const PASSWORD_RULES: { id: string; label: string; test: (v: string) => boolean }[] = [
  { id: "len", label: "Pelo menos 8 caracteres", test: (v) => v.length >= 8 },
  { id: "lower", label: "Uma letra minúscula", test: (v) => /[a-z]/.test(v) },
  { id: "upper", label: "Uma letra maiúscula", test: (v) => /[A-Z]/.test(v) },
  { id: "digit", label: "Um número", test: (v) => /\d/.test(v) },
  { id: "special", label: "Um caractere especial (ex.: @ # !)", test: (v) => /[^A-Za-z0-9]/.test(v) },
];

export const isStrongPassword = (value: string) =>
  PASSWORD_RULES.every((rule) => rule.test(value));

const PasswordRules: React.FC<{ value: string }> = ({ value }) => (
  <ul className="colabRules">
    {PASSWORD_RULES.map((rule) => (
      <li key={rule.id} className={rule.test(value) ? "is-ok" : ""}>
        {rule.label}
      </li>
    ))}
  </ul>
);

export default PasswordRules;
